import React from "react";
const HistoryItem = ({ children }) => {
	return <div className="historyItem">{children}</div>;
};

export default HistoryItem;
